import { deserialize } from 'cerialize'
import { AddressSuggest } from 'Models'

import {
	TYPE_ORGANIZATION,
	RbidosRequestStatuses,
	TYPE_DRS_CM_VISIT,
	PAID_STATUS,
	RegistratorCabinetGroupFile,
	RegistratorCabinetPayment,
	DivisionModel,
	TariffModel,
	CA_CALLBACK_STATE,
	TYPE_USTAV,
	AppointmentData,
	SberGeoUnitModel,
	ReserveAccountModel,
	ClientType,
} from 'Pages/registratorCabinet'
import { ProductModel } from 'Pages/orders'
import { FieldNames } from 'Constants/FieldNames'

export type DocumentFields = keyof UserDocs | keyof GeneratedDocs

export type UserDocs = {
	garant_mails: RegistratorCabinetGroupFile
	prilozh_docums: RegistratorCabinetGroupFile
	user_pasport_mains: RegistratorCabinetGroupFile
	user_pasport_propiskas: RegistratorCabinetGroupFile
	user_passport_fulls: RegistratorCabinetGroupFile
	ustavs: RegistratorCabinetGroupFile
}

export type GeneratedDocs = {
	garant_mails: RegistratorCabinetGroupFile
	ustavs: RegistratorCabinetGroupFile
	decision_ones: RegistratorCabinetGroupFile
	zayav_uls: RegistratorCabinetGroupFile
	zayav_ips: RegistratorCabinetGroupFile
	zayav_usns: RegistratorCabinetGroupFile
	covering_letter_uls: RegistratorCabinetGroupFile
	covering_letter_ips: RegistratorCabinetGroupFile
}

export class RbidosRequest {
	@deserialize public id: number
	@deserialize public last_name: string
	@deserialize public first_name: string
	@deserialize public middle_name: string
	@deserialize public phone: string
	@deserialize public email: string
	@deserialize public passport_series: string
	@deserialize public passport_number: string
	@deserialize public passport_series_number?: string
	@deserialize public passport_given_by: string
	@deserialize public gender: string
	@deserialize public snils: string
	@deserialize public inn: string
	@deserialize public company_name: string
	@deserialize public created_at: string
	@deserialize public customer_initials: string
	@deserialize public passport_given_date: string
	@deserialize public passport_given_dept: string
	@deserialize public birth_date: string
	@deserialize public birth_place: string
	@deserialize public locked_fields: FieldNames[]
	@deserialize public allowed_buttons: string[]
	@deserialize public code: string
	@deserialize public address: AddressSuggest
	@deserialize public org_type: TYPE_ORGANIZATION
	@deserialize public org_name: string
	@deserialize public org_short_name: string
	@deserialize public contact_phone: string
	@deserialize public authorized_capital_size: string
	@deserialize public juridical_address: AddressSuggest
	@deserialize public own_ustav: boolean
	@deserialize public postal_address: AddressSuggest
	@deserialize public same_address: boolean
	@deserialize public same_postal_address: boolean
	@deserialize public taxation_system: string
	@deserialize public covering_letter: boolean
	@deserialize public position: string
	@deserialize public position_customer: string
	@deserialize public chief_position_time_years: number
	@deserialize public okved_additionals_codes: string[]
	@deserialize public okved_main_code: string
	@deserialize public user_docs: UserDocs
	@deserialize public generated_docs: GeneratedDocs
	@deserialize public apply_generated_document: boolean
	@deserialize public payment: RegistratorCabinetPayment
	@deserialize public product_ids: number[]
	@deserialize public products: ProductModel[]
	@deserialize public locked_product_ids: number[]
	@deserialize public customer_identification_id: string
	@deserialize public permissions: Record<string, boolean>
	@deserialize public department: { id: number; name: string }

	@deserialize public partner_name: string
	@deserialize public rbo_client: boolean
	@deserialize public status: RbidosRequestStatuses
	@deserialize public territorial_bank: string
	@deserialize public updated_at: string
	@deserialize public user_email: string
	@deserialize public user_initials: string
	@deserialize public online_identification: boolean
	@deserialize public orders: {
		created_at: string
		id: number
		number: string
	}[]
	@deserialize public fns_callback_message: string
	@deserialize public autocreation_last_error_text: string
	@deserialize public passport_full: boolean
	@deserialize public rate: string
	@deserialize public otkritie_bank_city: string

	@deserialize public online_manager_product_ids: number[]
	@deserialize public online_product_ids: number[]
	@deserialize public add_info: string
	@deserialize public mcc_code_group: number
	@deserialize public mcc_group_id: number
	@deserialize public decision_maker_person_last_name: string
	@deserialize public decision_maker_person_first_name: string
	@deserialize public decision_maker_person_middle_name: string
	@deserialize public manager_last_name: string
	@deserialize public manager_first_name: string
	@deserialize public manager_middle_name: string
	@deserialize public finance_person_name: string
	@deserialize public finance_person_email: string
	@deserialize public operation_average_sum: number
	@deserialize public turn_over: string
	@deserialize public repeated_customer_identfication: boolean
	@deserialize public mcc_code_id: number
	@deserialize public install_region_id: number
	@deserialize public posaddress_fias_guid: string
	@deserialize public posaddress_fias_lvl: string
	@deserialize public posaddress: string
	@deserialize public manager_name: string
	@deserialize public manager_phone: string
	@deserialize public manager_email: string
	@deserialize public pos_name: string
	@deserialize public questions_contact_phone: string
	@deserialize public public_official_mark: boolean
	@deserialize public eio_mark: string
	@deserialize public title: string
	@deserialize public adrs_work: string
	@deserialize public payment_purpose_contract: string
	@deserialize public payment_purpose_contract_custom: string
	@deserialize public another_country_taxpayer_mark: boolean
	@deserialize public division: DivisionModel
	@deserialize public tariff: TariffModel
	@deserialize public tariff_code: string
	@deserialize public drs_tariff: TariffModel
	@deserialize public division_code: string
	@deserialize public equip_type: string
	@deserialize public equip_connect_type: string
	@deserialize public equip_amount: number
	@deserialize public email_for_docs: string
	@deserialize public international_org_name: string
	@deserialize public international_org_short_name: string
	@deserialize public site: string
	@deserialize public site_present: boolean
	@deserialize public important_status: string
	@deserialize public scenario: string
	@deserialize public authentication_link?: string
	@deserialize public external_errors_array?: string[]

	@deserialize public recommendation_product_ids: number[]
	@deserialize public product_request_relation_recommendations: { [key: string]: number }

	@deserialize public required_push_fields?: {
		docs: FieldNames[]
		fields: FieldNames[]
	}
	@deserialize public required_fields?: FieldNames[]
	@deserialize public with_reserve_account?: boolean
	@deserialize public drs_cm_visit_flag?: TYPE_DRS_CM_VISIT
	@deserialize public drs_sber_geo_unit?: SberGeoUnitModel
	@deserialize public reserve_account?: ReserveAccountModel | null
	@deserialize public rbidos_id: number
	@deserialize public paid_status: PAID_STATUS
	@deserialize public hide_founder_info?: boolean
	@deserialize public founder_info?: string
	@deserialize public manager?: string
	@deserialize public ca_callback_state?: CA_CALLBACK_STATE
	@deserialize public need_sms?: boolean

	@deserialize public posaddress_kladr_id?: string
	@deserialize public posaddress_postal_code?: string
	@deserialize public posaddress_street_type_full?: string
	@deserialize public posaddress_street?: string
	@deserialize public posaddress_house_type_full?: string
	@deserialize public posaddress_house?: string
	@deserialize public posaddress_flat?: string

	@deserialize public orgaddress_kladr_id?: string
	@deserialize public orgaddress_postal_code?: string
	@deserialize public orgaddress_street_type_full?: string
	@deserialize public orgaddress_street?: string
	@deserialize public orgaddress_house_type_full?: string
	@deserialize public orgaddress_house?: string
	@deserialize public orgaddress_flat?: string
	@deserialize public changed_at: string
	@deserialize public kfh_head: boolean
	@deserialize public charter_kind: TYPE_USTAV
	@deserialize public charter_number: number
	@deserialize public patent_application_enabled: boolean
	@deserialize public by_field_manager: boolean | null
	@deserialize public appointment_data?: AppointmentData
	@deserialize public ca_callback_all_errors?: CallbackError[]
	@deserialize public ca_callback_message?: string
	@deserialize public client_type: ClientType
}

export interface FnsLink {
	link: string
}

export type DrsTypeOffice = {
	drs_cm_visit_flag: TYPE_DRS_CM_VISIT
	sber_mq_region_id: string | number
	town_name: string
	id?: number
}

export interface CallbackError {
	error_message: string
	government_organization: string
}
